import { useEffect } from 'react';

import { QuotesLayout } from '../../../Components/Layout';

import { useSurveyAnswerContext } from '../../../Domains/SurveyAnswer/useSurveyContext';
import { prefixUrl } from '../../../Utils/mapAssetUrl';

const GoodThingsQuotes = () => {
  const { goToNextPage } = useSurveyAnswerContext();

  useEffect(() => {
    setTimeout(() => goToNextPage(), 6000);
  }, []);

  return (
    <QuotesLayout
      titleQuote={'สิ่งดี ๆ'}
      keyQuote={'กำลังจะเกิดขึ้น'}
      imageUrl={prefixUrl('/images/good-thing-quote.gif')}
    />
  );
};

const UseMoreTimeQuotes = () => {
  const { goToNextPage } = useSurveyAnswerContext();

  useEffect(() => {
    setTimeout(() => goToNextPage(), 6000);
  }, []);

  return (
    <QuotesLayout
      titleQuote={'ไอเดียดี ๆ'}
      keyQuote={'ต้องใช้เวลา'}
      imageUrl={prefixUrl('/images/more-time-quote.gif')}
    />
  );
};

const PassTogetherQuotes = () => {
  const { goToNextPage } = useSurveyAnswerContext();

  useEffect(() => {
    setTimeout(() => goToNextPage(), 6000);
  }, []);

  return (
    <QuotesLayout
      titleQuote={'เราทุกคน'}
      keyQuote={'จะผ่านไปด้วยกัน'}
      imageUrl={prefixUrl('/images/pass-together-quote.gif')}
    />
  );
};

export { GoodThingsQuotes, UseMoreTimeQuotes, PassTogetherQuotes };
